class Paths {
  static BASE_URL = "https://xml-podcast.herokuapp.com";
  // static BASE_URL = "http://localhost:5500";

  // User related routes
  static SIGNUP = "/user/signup";
  static PROFILE = "/user/me";
  static LOGIN = "/user/login";
  static UPDATE_PROFILE = "/user/update";
  static UPDATE_PASSWORD = "/user/update-password";
  static UPLOAD_IMAGE = "/user/update-profile-image";
  static DELETE_ACCOUNT = "/user/";
  static REMOVE_IMAGE = "/user/profile-image";

  // Podcast related paths
  static PUBLISH = "/podcast/publish";
  static SAVE = "/podcast/save";
  static GET_MY = "/podcast/getMy";
}

export default Paths;
